/* ===================================================================
   useApiToken() -- reactive read of the data-plane rr_ token.

   The data hooks (useReviews / useCustomers / useDashboardSummary) need
   to RE-ENABLE the instant a token is issued post-login. localStorage is
   not reactive, so we subscribe to the token store in src/lib/api.ts via
   useSyncExternalStore. When setToken() runs, every component using this
   hook re-renders and the disabled queries flip to enabled.
   =================================================================== */
import { useSyncExternalStore } from 'react';
import { subscribeToken, getTokenSnapshot } from '../lib/api';

export function useApiToken(): string | null {
  return useSyncExternalStore(subscribeToken, getTokenSnapshot, getTokenSnapshot);
}

export function useHasApiToken(): boolean {
  return Boolean(useApiToken());
}
